import * as React from 'react';
import * as styles from './styles.css';

import { UIText2 } from '@cian/ui-kit';

import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

export const MyHomeWithoutEstimation: React.FC = () => {
  return (
    <div data-testid="MyHomeWithoutEstimation" className={styles['container']}>
      <div className={styles['icon']}>
        <IconFunctionalInformationCircle16 color="icon-main-default" />
      </div>
      <UIText2>Сейчас не хватает данных для точной оценки, мы над этим работаем</UIText2>
    </div>
  );
};

MyHomeWithoutEstimation.displayName = 'MyHomeWithoutEstimation';
